import React from 'react';
import ContentWithNavigationSidebar from '../legacy/layouts/ContentWithNavigationSidebar';
import TeamMemberFile from '../legacy/pages/TeamMemberFile';
import Settings from '../legacy/pages/Settings';
import ROUTE_PATHS from './routePaths';

const routes = [
  {
    authenticatedRoute: true,
    path: `${ROUTE_PATHS.SETTINGS}/team-members/:teamMemberId`,
    component: props => (
      <ContentWithNavigationSidebar>
        <TeamMemberFile {...props} />
      </ContentWithNavigationSidebar>
    ),
  },

  {
    authenticatedRoute: true,
    path: ROUTE_PATHS.SETTINGS,
    component: props => (
      <ContentWithNavigationSidebar>
        <Settings {...props} />
      </ContentWithNavigationSidebar>
    ),
  },
];
export default routes;



// WEBPACK FOOTER //
// ./src/routes/settingRoutes.jsx